export default "__VITE_PUBLIC_ASSET__97d8036c__"